import { render, staticRenderFns } from "./DefaultErrors.vue?vue&type=template&id=2efc1602&scoped=true"
import script from "./DefaultErrors.vue?vue&type=script&lang=js"
export * from "./DefaultErrors.vue?vue&type=script&lang=js"
import style0 from "./DefaultErrors.vue?vue&type=style&index=0&id=2efc1602&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efc1602",
  null
  
)

export default component.exports